import {
  GET_PERSONAL_DETAILS,
  UPDATE_PERSONAL_DETAILS,
  GET_USER_EXTERNAL_ACCOUNTS,
  DELETE_USER_EXTERNAL_ACCOUNT,
  CREATE_USER_EXTERNAL_ACCOUNT,
  GET_USER_ACTIVITY
} from '@/services/settings'

import {
  GET_ADMIN_USERS,
  POST_NEW_USER,
  DELETE_USER,
  GET_USER_REQUESTS,
  GET_USER_SUB_USERS,
  GET_MY_DETAILS,
  GET_USER_DETAILS,
  POST_RESET_USER_PASSWORD,
  PUT_UPDATE_USER,
  POST_PRE_CREATE_PARTNER
} from '@/services/users'

const changeLocale = (context, locale) => {
  if (locale != undefined) {
    context.commit('CHANGE_LOCALE', locale)
  }
}

const loadPersonalDetails = () => {
  return GET_PERSONAL_DETAILS()
}

const deleteUser = (context, userId) => {
  return DELETE_USER(userId)
}

const postResetUserPassword = (context, userId) => {
  return POST_RESET_USER_PASSWORD(userId)
}

const getUserDetails = (context, userId) => {
  return GET_USER_DETAILS(userId)
}

const getMyDetails = () => {
  return GET_MY_DETAILS().then(res => {
    const {
      subscription: subscription,
      expiration_date: expirationDate,
      rol: rol,
      user_id: userId,
      parent_ref: parentRef,
      user_data: {
        PK: email,
        PK: userEmail,
        user_data: {
          first_name: userFirstName,
          last_name: userLastName,
          avatar_image: userAvatar,
          lang: locale,
          company_name: companyName,
          job_position: jobPosition,
          job_city: city,
          job_country: country,
          social_network: socialNetwork,
          deposit: deposit,
          admissions_comittee: admissionsComittee,
          kyc_information: kycInformation,
          nda_draft: ndaDraft,
          contract_draft: contractDraft,
          signed_nda: signedNDA,
          admission_date: admissionDate,
          signed_contract: signedContract,
          kyc
        }
      }
    } = res.data
    const userData = {
      email,
      userEmail,
      subscription,
      expirationDate,
      rol,
      userId,
      parentRef,
      userFirstName,
      userLastName,
      userAvatar,
      companyName,
      jobPosition,
      city,
      country,
      socialNetwork,
      locale,
      deposit,
      admissionsComittee,
      kycInformation,
      ndaDraft,
      contractDraft,
      signedNDA,
      admissionDate,
      signedContract,
      kyc
    }
    return new Promise(function(resolve) {
      resolve(userData)
    })
  })
}

const getUserRequests = (context, userId) => {
  return GET_USER_REQUESTS(userId)
}

const getUserSubUsers = (context, userId) => {
  return GET_USER_SUB_USERS(userId)
}

const postNewUser = (context, data) => {
  return POST_NEW_USER(data)
}

const postPreCreatePartner = (context, data) => {
  return POST_PRE_CREATE_PARTNER(data)
}

const updatePersonalDetails = (context, data) => {
  return UPDATE_PERSONAL_DETAILS(data)
}

const putUpdateUser = (_, payload) => {
  return PUT_UPDATE_USER(payload)
}

const changeRol = (context, rol) => {
  if (rol != undefined) {
    context.commit('CHANGE_ROL', rol)
  }
}

const changeAvatar = (context, image) => {
  if (image != undefined) {
    localStorage.setItem('avatar', image)
    context.commit('CHANGE_AVATAR', image)
  }
}

const getAdminUsers = () => {
  return GET_ADMIN_USERS()
}

const getUserActivity = () => {
  return GET_USER_ACTIVITY()
}

const getUserData = () => {
  return GET_USER_DATA()
}

const getUserExternalAccounts = () => {
  return GET_USER_EXTERNAL_ACCOUNTS()
}

const deleteUserExternalAccount = (context, accountId) => {
  return DELETE_USER_EXTERNAL_ACCOUNT(accountId)
}

const createUserExternalAccount = (context, data) => {
  return CREATE_USER_EXTERNAL_ACCOUNT(data)
}

export default {
  changeLocale,
  changeRol,
  loadPersonalDetails,
  getUserDetails,
  getMyDetails,
  getUserRequests,
  getUserSubUsers,
  updatePersonalDetails,
  getAdminUsers,
  changeAvatar,
  postResetUserPassword,
  getUserExternalAccounts,
  deleteUserExternalAccount,
  createUserExternalAccount,
  putUpdateUser,
  getUserActivity,
  postNewUser,
  postPreCreatePartner,
  getUserData,
  deleteUser
}
